import { normalizeTimestamp } from './normalize-timestamp';

export const formatMessageTime = timestamp => {
	const normalized = normalizeTimestamp(timestamp);
	if (!normalized) return '';

	const date = new Date(normalized);
	if (isNaN(date.getTime())) return '';

	return date.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	});
};
